import styled from 'styled-components';

export const ToolIframe = styled.iframe`
  width: 100%;
  height: calc(100vh - 10px);
`;

export const ToolWrapper = styled.section`
  max-width: 100%;
  margin: 0 auto;
  padding-top: 120px;
  background: #fff;
  @media (max-width: 720px) {
    padding-top: ${(props) => (props.removeTopSpace ? '0' : '56px')};
  }
`;
